import { getCustomerSubdomain } from './organizationType';

export default function subdomain(): string | null {
  return getCustomerSubdomain();
}
